import React, { Suspense, type FunctionComponent } from "react";
import { PostStatus, type IPost } from "../../../types/models/post.models.types";
import Spinner from "../../../components/spinner.components";


const InstagramEmbed = React.lazy(() =>
	import("react-social-media-embed").then((module) => ({
		default: module.InstagramEmbed,
	})),
);

interface IProps {
	post: IPost;
}

export const Post: FunctionComponent<IProps> = ({
	post,
}) => {
	switch (post.postStatus.status) {
		case PostStatus.draft:
		case PostStatus.draftApproved:
		case PostStatus.draftRejected:
			return (
				<>
					<div className="relative flex justify-center items-center w-full">
						{/* biome-ignore lint/a11y/useMediaCaption: <explanation> */}
						<video
							controls={true}
							src={post.draftAsset?.url}
							className="w-full h-96 cursor-pointer object-cover"
						/>
					</div>

					<div className="flex flex-col px-6 pt-5 pb-8 w-full font-semibold text-base">
						<p>{post.draftDescription}</p>
					</div>
				</>
			);
		case PostStatus.post:
		case PostStatus.postApproved:
		case PostStatus.postRejected:
		case PostStatus.disqualify:
		case PostStatus.flagged:
		case PostStatus.flaggedReview:
			if (!post.liveUrl) {
				throw new Error("live url not found");
			}
			return (
				<>
					<div className="w-full overflow-hidden">
						<Suspense fallback={<Spinner width={20} />}>
							<InstagramEmbed
								className="w-full"
								url={post.liveUrl}
								height={645}
								captioned={true}
							/>
						</Suspense>
					</div>
				</>
			);
	}
};
